import { RecentlyStudiedCourses } from "../../../../../models/state/userStats";
import { getCourseId } from "./recentlyStudiedCourse";

export function getRecentlyStudiedCourseIds(state: RecentlyStudiedCourses) {
  return state.map(getCourseId);
}
